import {Injectable, inject} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "./user.service";
import {BranchService} from "./branch.service";
import {AppToastService} from "./app-toast.service";
import {RouteService} from "./route.service";
import {CategoriesAndProductsTreeService} from "./categories-and-products-tree.service";
import {PushNotificationsService} from "@shared/services/push-notifications.service";
import {initializeApp} from "firebase/app";
import {FirebaseService} from "@app/+messaging/shared/services/firebase.service";
import {EmergencyService} from "./emergency.service";
// environment
import {environment} from "@environments/environment";
import {firstValueFrom} from "rxjs";
import {NgxSpinnerService} from "ngx-spinner";

@Injectable()
export class MainConfigurationService {
  private connectionIsLost = false;

  // dependencies
  private _translateService = inject(TranslateService);
  private _userService = inject(UserService);
  private _branchService = inject(BranchService);
  private _toast = inject(AppToastService);
  private _routeService = inject(RouteService);
  private _categoriesAndProductsTreeService = inject(
    CategoriesAndProductsTreeService
  );
  private _pushNotificationsService = inject(PushNotificationsService);
  private _firebaseService = inject(FirebaseService);
  private _spinner = inject(NgxSpinnerService);
  private _emergencyService = inject(EmergencyService);

  constructor() {}

  public async init() {
    this._translateService.use("fa");

    await this._userService
      .getToken()
      .then((value) => {
        if (value) {
          this._userService.createUserFromToken(value);
        }
      })
      .catch((err) => {})
      .finally(() => {
        this._spinner.hide();
      });

    if (this._userService.userSignal()?.id) {
      this._userService.getToken();
      this._addNetworkConnectionListeners();
      this._branchService.getBranchInfo();
      this._pushNotificationsService.requestPermission();
      this._routeService.init();
      this._branchService.branchInfo$.subscribe((info) => {
        this._categoriesAndProductsTreeService.init(info.warehouses?.[0]?.id);
      });

      // init emergency socket for logged-in users
      this._emergencyService.initEmergencySocket();
    }
    // call firebase initializer function
    const app = initializeApp(environment.firebase);
    this._firebaseService.requestPermission(app);
    this._firebaseService.listen(app);
  }

  private _addNetworkConnectionListeners() {
    window.addEventListener("offline", () => {
      this.connectionIsLost = true;
      this._toast.error("لطفا ارتباط خود را با اینترنت بررسی کنید.");
    });

    window.addEventListener("online", () => {
      if (this.connectionIsLost) {
        this.connectionIsLost = false;
        this._toast.success("ارتباط شما با اینترنت مجددا برقرار شد.");
      }
    });
  }
}
